module.exports = __webpack_public_path__ + "img/logo.78696a9e.png";